export const CopyTextIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33333 6.5C6.8731 6.5 6.5 6.8731 6.5 7.33333V13.3333C6.5 13.7936 6.8731 14.1667 7.33333 14.1667H13.3333C13.7936 14.1667 14.1667 13.7936 14.1667 13.3333V7.33333C14.1667 6.8731 13.7936 6.5 13.3333 6.5H7.33333ZM5.5 7.33333C5.5 6.32081 6.32081 5.5 7.33333 5.5H13.3333C14.3459 5.5 15.1667 6.32081 15.1667 7.33333V13.3333C15.1667 14.3459 14.3459 15.1667 13.3333 15.1667H7.33333C6.32081 15.1667 5.5 14.3459 5.5 13.3333V7.33333Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66666 1.83331C2.44565 1.83331 2.23369 1.92111 2.07741 2.07739C1.92113 2.23367 1.83333 2.44563 1.83333 2.66665V8.66665C1.83333 8.88766 1.92113 9.09962 2.07741 9.2559C2.23369 9.41218 2.44565 9.49998 2.66666 9.49998H3.33333C3.60947 9.49998 3.83333 9.72384 3.83333 9.99998C3.83333 10.2761 3.60947 10.5 3.33333 10.5H2.66666C2.18043 10.5 1.71412 10.3068 1.3703 9.96301C1.02648 9.61919 0.833328 9.15288 0.833328 8.66665V2.66665C0.833328 2.18042 1.02648 1.7141 1.3703 1.37028C1.71412 1.02647 2.18043 0.833313 2.66666 0.833313H8.66666C9.15289 0.833313 9.61921 1.02647 9.96302 1.37028C10.3068 1.7141 10.5 2.18042 10.5 2.66665V3.33331C10.5 3.60946 10.2761 3.83331 10 3.83331C9.72385 3.83331 9.5 3.60946 9.5 3.33331V2.66665C9.5 2.44563 9.4122 2.23367 9.25592 2.07739C9.09964 1.92111 8.88768 1.83331 8.66666 1.83331H2.66666Z"
        fill="white"
      />
    </svg>
  )
}
